import styles from "./Intro.module.css"

export default function Intro(){
  return (
    <section className={styles.intro}>
      <div className={styles.intro_image}></div>
      <div className={styles.intro_info}>
        <h1 className={styles.info_name}>Daanyal Shareef</h1>
        <p className={styles.info_description}>
          Code, Data, and the Drive for Innovation
        </p>
      </div>
    </section>
  );
}